export default "__VITE_ASSET__DmOMiNi6__"